export var BREAKPOINTS;
(function (BREAKPOINTS) {
    BREAKPOINTS[BREAKPOINTS["NARROW"] = 0] = "NARROW";
    BREAKPOINTS[BREAKPOINTS["MEDIUM"] = 768] = "MEDIUM";
    BREAKPOINTS[BREAKPOINTS["WIDE"] = 1024] = "WIDE";
    BREAKPOINTS[BREAKPOINTS["EXWIDE"] = 1280] = "EXWIDE";
})(BREAKPOINTS || (BREAKPOINTS = {}));
export const VIEWPORT_CONSTRAINTS = {
    'up-to-narrow': `(max-width: ${BREAKPOINTS.NARROW}px)`,
    narrow: `(min-width: ${BREAKPOINTS.NARROW}px)`,
    'narrow-to-medium': `(min-width: ${BREAKPOINTS.NARROW}px) and (max-width: ${BREAKPOINTS.MEDIUM}px)`,
    medium: `(min-width: ${BREAKPOINTS.MEDIUM}px)`,
    'medium-to-wide': `(min-width: ${BREAKPOINTS.MEDIUM}px) and (max-width: ${BREAKPOINTS.WIDE}px)`,
    wide: `(min-width: ${BREAKPOINTS.WIDE}px)`,
    'wide-to-extra-wide': `(min-width: ${BREAKPOINTS.WIDE}px) and (max-width: ${BREAKPOINTS.EXWIDE}px)`,
    'extra-wide': `(min-width: ${BREAKPOINTS.EXWIDE}px)`,
};
export const responsiveViewportMatcher = (breakpoint) => {
    return window.matchMedia(VIEWPORT_CONSTRAINTS[breakpoint]).matches;
};
